export interface IComparisonConversionTotals {
    centerAlias: string,
    donorCareNetworkCount: number,
    voucherProgramCount: number,
    donorShieldDirectCountKidney: number,
    donorShieldDirectCountLiver: number,
    followUpEnabledCount: number,
    plDashCenterCount: number,
    micrositeCenterCount: number,
    micrositeCenterOfExcellenceCount: number,
    nkrReferralNetworkCount: number,
    donorConnectEnabledCount: number,
    expertSystemCount: number,
    priorYearRegistrationsCount: number,
    priorYearReferralsCount: number,
    reportYearRegistrationsCount: number,
    reportYearReferralsCount: number,
    reportYearDonationsCount: number,
    referredCountAverageCount: number,
    referralConversionRatePercent: number,
    nkrDonationsCount: number,
    nkrConversionRatePercent: number,
    directDonatedCount: number,
    directDonatedConversionRatePercent: number,
    disconnectCount: number,
    disconnectConversionRatePercent: number,
    registeredCountAverageCount: number,
    priorYearMedian: number,
    reportYearMedian: number,
    registeredConversionRatePercent: number,
    donatedCountAnnualizedCount: number,
    isExpertSystem: boolean
}